import { useState } from 'react';

export const useCarouselArrows = (sliderRef) => {
  const [arrowDisabled, setArrowDisabled] = useState({ left: true, right: false });
  const [displayArrows, setDisplayArrows] = useState(false);

  const handleBeforeChange = (oldIndex, newIndex, slidesCount) => {
    const currentBreakpoint = sliderRef.current.state.breakpoint;
    const currentSlidesToShow = sliderRef.current.props.responsive.find(rule => rule.breakpoint === currentBreakpoint)?.settings.slidesToShow || 3;
    setArrowDisabled({
      left: 0 === newIndex,
      right: newIndex >= slidesCount - currentSlidesToShow
    });
  };

  const onReInit = (slidesCount) => {
    const currentBreakpoint = sliderRef.current.state.breakpoint;
    const currentSlidesToShow = sliderRef.current.props.responsive.find(rule => rule.breakpoint === currentBreakpoint)?.settings.slidesToShow || 3;
    if (slidesCount <= currentSlidesToShow) {
      setDisplayArrows(false);
    } else {
      setDisplayArrows(true);
    }

    const carouselElements = document.querySelectorAll('.CarouselSection > .slick-list > .slick-track > .slick-slide');
    carouselElements.forEach((element) => {
      if (element.getAttribute('aria-hidden') === 'true') {
        element.setAttribute('aria-hidden', 'false');
        return;
      }
    });
  };

  return {
    arrowDisabled,
    displayArrows,
    handleBeforeChange,
    onReInit
  };
};
